// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"e6e641ce","485":"517988f2","580":"fa19b5f6","634":"694a8067","753":"bebea83f"}[chunkId] + ".chunk.css";
};